import { gql } from "@apollo/client";

export const GET_OFFICERS_ON_INCIDENT_FOR_MAP = gql`
  query GET_OFFICERS_ON_INCIDENT_FOR_MAP($incidentId: ID!, $originatorId: ID!) {
    initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
      __typename
      officerIncidentSpecifics {
        officer {
          id
          lat
          lng
          accuracy
          locationUpdatedAt
          locationSource
          personalAttribute {
            id
            lastName
            middleName
            firstName
          }
          deptAttribute {
            onDuty
            badge
            carNumber
            id
            radioNumber
            status
            ori {
              abbreviation
            }
          }
        }
      }
    }
  }
`;
